import React from 'react';
import Tooltip from '../../tooltip';
const EllipsisTooltip = ({ title, enabledEllipsis, children, }) => {
    if (!title || !enabledEllipsis) {
        return children;
    }
    return (React.createElement(Tooltip, { title: title }, children));
};
EllipsisTooltip.displayName = 'EllipsisTooltip';
export default EllipsisTooltip;
